module.exports = __webpack_public_path__ + "5f10a92bacc4db74e1b25f876da8fcd7.png";